/**
 * Maps a numeric Bank of Israel code (returned by the bank-confirmation OCR
 * processor as `bankCode`) to the Pipedrive dropdown option for the שם הבנק
 * field on Step 5. Pipedrive labels embed the code in trailing parentheses,
 * e.g. `לאומי (10)`, so we resolve by parsing that suffix rather than
 * maintaining a hardcoded code→name table.
 */

import type { OnboardingOption } from 'features/onboarding/api/options';

const BANK_CODE_IN_LABEL = /\((\d+)\)\s*$/;

export const extractBankCodeFromLabel = (label: string): string | undefined => {
  const m = label.match(BANK_CODE_IN_LABEL);
  return m ? m[1] : undefined;
};

export const resolveBankNameFromCode = (
  bankCode: string | null | undefined,
  banks: OnboardingOption[] | undefined,
): string | undefined => {
  if (!bankCode || !banks?.length) return undefined;
  const digits = String(bankCode).replace(/\D/g, '');
  if (!digits) return undefined;
  const match = banks.find((b) => extractBankCodeFromLabel(b.label) === digits);
  return match?.label;
};
